import { addToast, Button, SelectOptionType } from '@octano/global-ui';
import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Card, Col, Container, Row } from 'reactstrap';
import { createScheduleRequest } from '../../../api/requests/schedules';
import GoBackButton from '../../../components/buttons/GoBackButton';
import { useLayoutState } from '../../../hooks/useLayoutState';
import { useSIESConfig } from '../../../hooks/useSIESConfig';
import ScheduleForm, { ScheduleValues } from './ScheduleForm';

const ScheduleRecordCreate = () => {
  const prefix = 'maintainers.scheduleForm';
  const { t } = useTranslation();
  const { hideTabs } = useLayoutState();

  const siesSchedules = useMemo<SelectOptionType[]>(
    () => [
      {
        value: '1',
        label: t('sies.schedule.1'),
      },
      {
        value: '2',
        label: t('sies.schedule.2'),
      },
      {
        value: '3',
        label: t('sies.schedule.3'),
      },
      {
        value: '4',
        label: t('sies.schedule.4'),
      },
      {
        value: '5',
        label: t('sies.schedule.5'),
      },
    ],
    [t],
  );

  const { siesEnabled } = useSIESConfig();

  useEffect(() => {
    hideTabs();
  }, [hideTabs]);

  let history = useHistory();
  const goBack = useCallback(() => {
    history.push(`/maintainers/schedules`);
  }, [history]);

  const onSubmit = useCallback(
    async (values: ScheduleValues) => {
      const response = await createScheduleRequest(values);
      if (!response.error) {
        addToast({
          icon: 'success',
          color: 'success',
          text: t(`${prefix}.createSuccess`),
        });
        goBack();
      } else {
        return response.error.code;
      }
    },
    [goBack, t],
  );

  return (
    <Container>
      <Card className="p-3 p-md-4">
        <div className="mb-4">
          <GoBackButton onClick={goBack} />
        </div>
        <ScheduleForm
          siesSchedules={siesSchedules}
          siesEnabled={siesEnabled}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Row>
              <Col
                xs={{ order: 2, size: 12 }}
                md={{ order: 1, size: 4 }}
                className="ml-auto"
              >
                <div>
                  <Button
                    type="button"
                    text={t(`common.actions.cancel`)}
                    outlined
                    onClick={goBack}
                    fullwidth
                  />
                </div>
              </Col>

              <Col xs={{ order: 1, size: 12 }} md={{ order: 2, size: 4 }}>
                <div className="pb-3 pb-md-0">
                  <Button
                    type="submit"
                    text={t(`${prefix}.createSchedule`)}
                    loading={isSubmitting}
                    fullwidth
                  />
                </div>
              </Col>
            </Row>
          )}
        </ScheduleForm>
      </Card>
    </Container>
  );
};

export default ScheduleRecordCreate;
